<div slot="input" class="flex gap-5 items-center">
  @if (imageUrl(); as src) {
    <img
      [src]="src"
      alt="Preview"
      class="object-contain flex-none w-20 h-20 outline outline-1 outline-offset-[-1px] outline-outline dark:outline-outline-darkmode overflow-hidden bg-surface-variant dark:bg-surface-variant-darkmode"
      [class.rounded-lg]="rounded() === 'lg'"
      [class.rounded-full]="rounded() === 'full'"
      (load)="onImageLoad()"
    />
  } @else {
    <div
      class="flex-none w-20 h-20 relative outline outline-1 outline-offset-[-1px] outline-outline dark:outline-outline-darkmode overflow-hidden bg-surface-variant dark:bg-surface-variant-darkmode flex items-center justify-center"
      [class.rounded-lg]="rounded() === 'lg'"
      [class.rounded-full]="rounded() === 'full'"
    >
      <div class="text-on-surface-disabled">
        <ng-icon [name]="icon()" size="40" class="!block" />
      </div>
    </div>
  }
  <ui-button mode="outlined" type="button" (click)="input.click()" [disabled]="disabled()">
    <ng-content />
  </ui-button>
</div>
<input
  type="file"
  class="hidden"
  #input
  [accept]="accept()"
  (change)="onFileInputChange($event.target.files)"
  [disabled]="disabled()"
/>
